/* Name:Chaitali Khachane
   Description:This file  define the routes for different URL paths like dataAsset, data Domain, data Assets etc.
               to corresponding React components that should be rendered when the user visits those paths.
*/
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import OuterFrame from "../component/outerFrame/outerFrame";
import DataAssetPage from "../pages/dataAssets/dataAssetPage";
import DataAssestsViewAll from "../pages/dataAssets/dataAssetsViewAll";
import Home from "../pages/home";
import DataDomainPage from "../pages/dataDomain/dataDomainPage";
import SubDomain from "../pages/dataDomain/subDomain";
import AccessManagement from "../pages/accessManagement/accessManagement";
import RuleElevation from "../pages/rulePage/RuleElevationPage";
import ProductOnBoarding from "../pages/OnBoardingProduct/ProductOnBoarding";
import MainMenu from "../nav/MainMenu";
import Dashboard from "../pages/dashboard/Dashboard";
import DataMonitoring from "../pages/DataMonitoring/DataMonitoring";
import DataTrafficLights from "../pages/dataTrafficLights/DataTrafficLights";
import DataContract from "../pages/dataContract/DataContract";
import LandingPage from "../pages/dataDomain/LandingPage";
import { ProtectedRoute } from "../components/ProtectedRoute";
import Action from "../pages/ActionPage/Action";
import DataProduct from "../pages/DataProduct/DataProduct";
import Versioning from "../pages/Versioning/Versioning";
import SavedDataProduct from "../pages/DataProductSaved/SavedDataProduct";

 
 
function MainRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ruleElevation" element={
          <OuterFrame>
            <RuleElevation />
          </OuterFrame>
        } />
        <Route
          path="/accessManagement"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <MainMenu text1={"Access Management"}>
                <AccessManagement />
              </MainMenu>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dataAssets"
          element={
            <OuterFrame>
              <DataAssestsViewAll />
            </OuterFrame>
          }
        />
        <Route
          path="/dataAsset/:dataAssetId"
          element={
            <OuterFrame>
              <DataAssetPage />
            </OuterFrame>
          }
        />
        <Route
          path="/dataDomain"
          element={
            <MainMenu text1={"Aays Data Marketplace"}  text2={"Domain Management"} padding={false}>
              <LandingPage />
            </MainMenu>
          }
        />
        <Route
          path="/dataSubDomain"
          element={
            <OuterFrame>
              <SubDomain />
            </OuterFrame>
          }
        />
 
        <Route
          path="/product-onboarding"
          element={
            <MainMenu text1={"Aays Data Marketplace"} padding={true}>
              <ProductOnBoarding />
            </MainMenu>
          }
        />
 
          <Route
          path="/product-onboarding/:id"
          element={
            <MainMenu text1={"Aays Data Marketplace"} padding={true}>
              <ProductOnBoarding />
            </MainMenu>
          }
        />
 
 
        <Route
          path="/data-traffic-lights"
          element={
            <MainMenu text1={"Aays Data Marketplace"} text2={"Data Traffic Lights"} padding={false}>
              <DataTrafficLights />
            </MainMenu>
          }
        />
 
        <Route
          path="/dashboard"
          element={
            <MainMenu text1={"Aays Data Marketplace"} text2={"Overview"} padding={false}>
              <Dashboard />
            </MainMenu>
          }
        />
 
        <Route
          path="/data-monitoring"
          element={
            <MainMenu text1={"Aays Data Marketplace"} text2={"Data Monitoring"} padding={false}>
              <DataMonitoring />
            </MainMenu>
          }
        />

        <Route
          path="/action"
          element={
            <MainMenu text1={"Aays Data Marketplace"} text2={"Actions"} padding={false}>
              <Action />
            </MainMenu>
          }
        />
      <Route
          path="/versioning"
          element={
            <MainMenu text1={"Aays Data Marketplace"} text2={"Versioning"} padding={true}>
              <Versioning />
            </MainMenu>
          }
        /> 
         <Route
          path="/versioning/:id"
          element={
            <MainMenu text1={"Versioning"} padding={true}>
              <Versioning />
            </MainMenu>
          }
        />
        <Route
         path="/product-report/:productId"
        element={
          <MainMenu text1={"Product Report"} padding={false}>
            <DataProduct />
          </MainMenu>
        }
        />
        <Route
  path="/product-report/dashboard-view/:dashboardId"
  element={
   <MainMenu text1={"Product Report"} padding={false}>
            <SavedDataProduct />
          </MainMenu>
          }
/>
        <Route
          path="/data-contract"
          element={
            <MainMenu text1={"Aays Data Marketplace"} text2={"Data Discovery"} padding={true}>
              <DataContract />
            </MainMenu>
          }
        />
        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}
 
export default MainRoutes;